import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var LockFreeLinkedListNodeClass;
function LockFreeLinkedListNode() {
  if (LockFreeLinkedListNodeClass === VOID) {
    class $ {
      constructor() {
        this.j12_1 = this;
        this.k12_1 = this;
        this.l12_1 = false;
      }
      m12(node, permissionsBitmask) {
        var prev = this.k12_1;
        var tmp;
        if (prev instanceof ListClosed()) {
          tmp = ((prev.q1l_1 & permissionsBitmask) === 0 && prev.m12(node, permissionsBitmask));
        } else {
          node.j12_1 = this;
          node.k12_1 = prev;
          prev.j12_1 = node;
          this.k12_1 = node;
          tmp = true;
        }
        return tmp;
      }
      b15(forbiddenElementsBit) {
        this.m12(new (ListClosed())(forbiddenElementsBit), forbiddenElementsBit);
      }
      n12() {
        if (this.l12_1)
          return false;
        var prev = this.k12_1;
        var next = this.j12_1;
        prev.j12_1 = next;
        next.k12_1 = prev;
        this.l12_1 = true;
        return true;
      }
      o12(node) {
        if (!(this.j12_1 === this))
          return false;
        this.m12(node, -2147483648);
        return true;
      }
    }
    initMetadataForClass($, 'LockFreeLinkedListNode', LockFreeLinkedListNode);
    LockFreeLinkedListNodeClass = $;
  }
  return LockFreeLinkedListNodeClass;
}
var LockFreeLinkedListHeadClass;
function LockFreeLinkedListHead() {
  if (LockFreeLinkedListHeadClass === VOID) {
    class $ extends LockFreeLinkedListNode() {}
    initMetadataForClass($, 'LockFreeLinkedListHead', LockFreeLinkedListHead);
    LockFreeLinkedListHeadClass = $;
  }
  return LockFreeLinkedListHeadClass;
}
var ListClosedClass;
function ListClosed() {
  if (ListClosedClass === VOID) {
    class $ extends LockFreeLinkedListNode() {
      constructor(forbiddenElementsBitmask) {
        super();
        this.q1l_1 = forbiddenElementsBitmask;
      }
    }
    initMetadataForClass($, 'ListClosed');
    ListClosedClass = $;
  }
  return ListClosedClass;
}
//region block: exports
export {
  LockFreeLinkedListHead as LockFreeLinkedListHeaduwhs9comnpmn,
  LockFreeLinkedListNode as LockFreeLinkedListNode18403qmazubk5,
};
//endregion

//# sourceMappingURL=LinkedList.mjs.map
